// extracted by mini-css-extract-plugin
export var active = "_2o-2";
export var highlight = "_2o-1";
export var highlightLayer = "_2o-0";
export var issuePopover = "_2o-3";
export var statusIcon = "_2o-4";